import { KeyboardArrowRight } from "@mui/icons-material";
import clsx from "clsx";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";

interface IRideSaveRouteIndicator {
  isRouteDeleted?: boolean;
  isRoutePaused?: boolean;
  isMlPathIgnored?: boolean;
  stationRouteId?: number | null;
}

export const SaveRouteIndicatorRight: FC<IRideSaveRouteIndicator> = ({
  isRouteDeleted,
  isRoutePaused,
  isMlPathIgnored,
  stationRouteId,
}) => {
  const shouldShowSaveArrow = Boolean(
    isRouteDeleted || !stationRouteId || isRoutePaused || isMlPathIgnored,
  );
  const shouldShowEditablePen = Boolean(
    stationRouteId && !isRouteDeleted && !isRoutePaused,
  );

  const isRightIconDisplayed = shouldShowSaveArrow || shouldShowEditablePen;
  return (
    <>
      {isRightIconDisplayed && <div className="separator"></div>}
      {shouldShowSaveArrow && (
        <KeyboardArrowRight
          className={clsx({
            indicatorIcon: true,
            rtl_rotate: true,
            iconDeleted: isRouteDeleted,
            iconGrey: !isRouteDeleted,
          })}
        />
      )}
      {shouldShowEditablePen && (
        <SVG_MUI.EditablePenSVG className="indicatorIcon" />
      )}
    </>
  );
};
